import React from 'react'
import { observer } from 'mobx-react'
import { payPlanMobx } from '@mobxStore'
import BankCardSimpleItem from './SimpleItem'

const MethodItem = ({ method, selected, bankCards }: { method: IBankCardOnlinePayMethod; selected?: boolean; bankCards?: IMutBankCardInfo[] }) => {
  const amount = method?.amount
  const card = method?.bankCardInfo
  const channel = method?.channel

  const onClick = () => {
    if (!selected) {
      payPlanMobx.changeExternalPayMethod('BankCardOnline')
    }
  }

  return (
    <BankCardSimpleItem bankCards={bankCards} selected={selected} amount={amount} channel={channel} onChange={onClick} card={card} />
  )
}

export default observer(MethodItem)
